import { React } from 'Imports';
import * as scssStyles from '$CSS/settings.scss';
import { Switch, styled } from 'MaterialUIComponents';
import { switchClasses } from '@mui/material/Switch';
import { Box } from '@mui/material';

const styles = require('$Components/FilterComponents/Filters/DropdownSwitch.scss') as {
    toggle: string;
    toggleText: string;
};

interface IDropdownSwitchProps {
    checked: boolean;
    onChange: () => void;
    toggleText: string;
    textClassName?: string;
    disabled?: boolean;
}

const StyledDropdownSwitch = styled(Switch)(({ theme }) => ({
    width: 30,
    height: 16,
    padding: 0,
    [`& .${switchClasses.switchBase}`]: {
        padding: 0,
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor: 'transparent',
        },
        [`&.${switchClasses.checked}`]: {
            transform: 'translateX(14px)',
            [`& + .${switchClasses.track}`]: {
                backgroundColor: scssStyles.multiSelectSwitchBaseCheckedColor,
                opacity: 2,
                border: 'none',
            },
        },
    },
    [`& .${switchClasses.thumb}`]: {
        width: 12,
        height: 12,
        transform: 'translateY(2px) translateX(2px)',
        marginRight: 2,
        color: theme.palette.common.white,
    },
    [`& .${switchClasses.track}`]: {
        width: 30,
        height: 16,
        borderRadius: 7,
        backgroundColor: scssStyles.multiSelectSwitchTrackColor,
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
}));

const DropdownSwitch = (props: IDropdownSwitchProps) => {
    return (
        <Box className={styles.toggle}>
            <Box>
                <StyledDropdownSwitch disableRipple onChange={props.onChange} checked={props.checked} disabled={props.disabled} />
            </Box>
            <Box className={`${styles.toggleText}${props.textClassName ? ` ${props.textClassName}` : ''}`}>{props.toggleText}</Box>
        </Box>
    );
};

export default DropdownSwitch;
